//using https://micromodal.now.sh/
import MicroModal from 'micromodal';

export default function init()
{
    console.log('MicroModal inside component.');
    // Added code below to repair a known issue with MicroModal See; https://github.com/ghosh/Micromodal/issues/324
    MicroModal.init({
        disableFocus: true,
        onClose: function (modal, element, event) {
            event.preventDefault();
            event.stopPropagation();
        },
    });
}


